import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';
import {images} from '../constants';
export const LayoutFooterDark = {
  factory: EElement({
    id: 'cfbfe1ab-8991-e12e-939f-888fcc30e7ad',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('948d968a-f454-5181-9913-ae3dd7a49790')]),
      children: EList([
        EElement({
          id: 'cfbfe1ab-8991-e12e-939f-888fcc30e7ae',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'e231d58e-6e64-f37b-2445-1a1238202af2',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('12813dd1-1e35-eba3-74a7-c3085212d02a'),
                  ]),
                  children: EList([
                    EElement({
                      id: '4778ccda-d8d9-4369-5f6e-5065d006d2e8',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Link')
                      ),
                      data: ERecord({
                        button: EBoolean(false),
                        block: EText('inline'),
                        eventIds: EList([]),
                        link: ELiteral({
                          name: qualify(
                            Plugins.name('Basic'),
                            typeName('Link')
                          ),
                          value: JSON.parse('{"mode":"external","url":"#"}'),
                        }),
                        styleBlockIds: EList([
                          EText('53b66045-edd4-1887-44fa-4a01827a4b31'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd07bb57e-7df6-11ac-e7b6-8adb6949daaf',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.companyLogoPlaceholder),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272de3851627857066e9029"}'
                                ),
                              }),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'e8d8e896-c3bd-e314-3b3e-cb61efc322b5',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('35aa4301-cb7a-d2a7-33f6-94294fdc6ecc'),
                        ]),
                        children: EList([
                          EElement({
                            id: '89544449-a833-a944-c767-47237e0ba4d3',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('47d9bdd6-1c60-11c5-ba75-57d4613510d2'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '6329babe-5be0-7f93-aafc-1c3f899dbe64',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        'c7b87836-47af-51ef-360f-c3c02ab58565'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '6329babe-5be0-7f93-aafc-1c3f899dbe65',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Company'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '3f5b89fe-17b9-a8c0-d954-96f012117776',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '3f5b89fe-17b9-a8c0-d954-96f012117777',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('How it works'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'e138c8da-cbd4-55e7-be2e-bb74f9429009',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'e138c8da-cbd4-55e7-be2e-bb74f942900a',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Pricing'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'f7c5651d-f970-2648-bc24-8ebc22a5fd20',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'f7c5651d-f970-2648-bc24-8ebc22a5fd21',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Docs'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'a2c3a290-e2bd-6eff-3860-747a3bd31cbd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('47d9bdd6-1c60-11c5-ba75-57d4613510d2'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'a2c3a290-e2bd-6eff-3860-747a3bd31cbe',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        'c7b87836-47af-51ef-360f-c3c02ab58565'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'a2c3a290-e2bd-6eff-3860-747a3bd31cbf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Resources'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'a2c3a290-e2bd-6eff-3860-747a3bd31cc0',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'a2c3a290-e2bd-6eff-3860-747a3bd31cc1',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Blog post name list goes here'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '30e1dd8a-9c2f-c35c-07d3-e5d4b56a48b9',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '30e1dd8a-9c2f-c35c-07d3-e5d4b56a48ba',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Blog post name list goes here'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'eee6f02f-8b88-233e-517e-a95bc6ea7080',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'eee6f02f-8b88-233e-517e-a95bc6ea7081',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Blog post name list goes here'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'd52691a8-a89d-5684-9613-2e902bc45e20',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'd52691a8-a89d-5684-9613-2e902bc45e21',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('See all resources >'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e3',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('47d9bdd6-1c60-11c5-ba75-57d4613510d2'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e4',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    styleBlockIds: EList([
                                      EText(
                                        'c7b87836-47af-51ef-360f-c3c02ab58565'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e5',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('About'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e6',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Terms & Conditions'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Link')
                                  ),
                                  data: ERecord({
                                    button: EBoolean(false),
                                    eventIds: EList([]),
                                    link: ELiteral({
                                      name: qualify(
                                        Plugins.name('Basic'),
                                        typeName('Link')
                                      ),
                                      value: JSON.parse(
                                        '{"mode":"external","url":"#"}'
                                      ),
                                    }),
                                    block: EText(''),
                                    styleBlockIds: EList([
                                      EText(
                                        '8caebbb9-222c-79d6-8d8e-489d3df5f5a1'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'b71ebccf-232f-c757-51c5-fef9d3baf1e9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Privacy policy'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: 'ce9722cd-d25d-fd0e-2494-6455f0297877',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'f313109b-a9f0-82bf-ee6a-7cb4500493e0'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'b9567626-5d91-2fed-b558-08e7e3a8b0a3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Link')
                                        ),
                                        data: ERecord({
                                          button: EBoolean(false),
                                          eventIds: EList([]),
                                          block: EText('inline'),
                                          link: ELiteral({
                                            name: qualify(
                                              Plugins.name('Basic'),
                                              typeName('Link')
                                            ),
                                            value: JSON.parse(
                                              '{"mode":"external","url":"#"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '7543ee55-a53c-7b23-437f-8e3d319742b8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'acf2695d-4f61-dec8-e180-dfa91c9237df',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.twitterLogoSmallDark
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"6272de3851627857066e8ffa"}'
                                                  ),
                                                }),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '59e42ca2-39f7-3118-edb1-fc1e27f2e8b7',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Link')
                                        ),
                                        data: ERecord({
                                          button: EBoolean(false),
                                          eventIds: EList([]),
                                          block: EText('inline'),
                                          link: ELiteral({
                                            name: qualify(
                                              Plugins.name('Basic'),
                                              typeName('Link')
                                            ),
                                            value: JSON.parse(
                                              '{"mode":"external","url":"#"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '7543ee55-a53c-7b23-437f-8e3d319742b8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '59e42ca2-39f7-3118-edb1-fc1e27f2e8b8',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.linkedinLogoSmallDark
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"6272de3851627857066e9009"}'
                                                  ),
                                                }),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '2b5d59f9-317a-69fb-b4e8-65dcbb991383',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Link')
                                        ),
                                        data: ERecord({
                                          button: EBoolean(false),
                                          eventIds: EList([]),
                                          block: EText('inline'),
                                          link: ELiteral({
                                            name: qualify(
                                              Plugins.name('Basic'),
                                              typeName('Link')
                                            ),
                                            value: JSON.parse(
                                              '{"mode":"external","url":"#"}'
                                            ),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '7543ee55-a53c-7b23-437f-8e3d319742b8'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '2b5d59f9-317a-69fb-b4e8-65dcbb991384',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Image')
                                              ),
                                              data: ERecord({
                                                attr: ERecord({
                                                  src: EText(
                                                    images.facebookLogoSmallDark
                                                  ),
                                                  loading: EEnum('lazy'),
                                                  width: EText('auto'),
                                                  height: EText('auto'),
                                                  alt: EText(
                                                    '__wf_reserved_inherit'
                                                  ),
                                                }),
                                                img: ELiteral({
                                                  name: qualify(
                                                    Plugins.name('Asset'),
                                                    typeName('Image')
                                                  ),
                                                  value: JSON.parse(
                                                    '{"id":"6272de3851627857066e902a"}'
                                                  ),
                                                }),
                                                temp: ERecord({
                                                  img: ERecord({
                                                    src: EText(''),
                                                  }),
                                                }),
                                                srcsetDisabled: EBoolean(false),
                                                sizes: EList([]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
        EElement({
          id: 'bd517fd4-2bf2-dbf0-c9ae-1da830668b2a',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('85355063-dd48-e9d4-b0bd-28842db06b01'),
            ]),
            children: EList([]),
          }),
        }),
        EElement({
          id: '23ced44b-44ae-f523-c7c6-f8ef2bf423d9',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            text: EBoolean(true),
            tag: EEnum('div'),
            styleBlockIds: EList([
              EText('bc2a7d39-c31e-404b-43ad-f4eab7f73dbb'),
            ]),
            children: EList([
              EElement({
                id: '23ced44b-44ae-f523-c7c6-f8ef2bf423da',
                type: qualify(Plugins.name('Basic'), Component.name('String')),
                data: EText('Copyright \xA9 2021 Company name'),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '948d968a-f454-5181-9913-ae3dd7a49790',
      type: 'class',
      name: 'Footer Dark',
      comb: '',
      styleLess:
        'position: relative; padding-top: 50px; padding-right: 30px; padding-bottom: 15px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {styleLess: 'padding-right: 15px; padding-left: 15px;'},
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '12813dd1-1e35-eba3-74a7-c3085212d02a',
      type: 'class',
      name: 'Footer Wrapper',
      comb: '',
      styleLess:
        'display: flex; max-width: 900px; margin-right: auto; margin-left: auto; justify-content: space-between; align-items: flex-start;',
      children: [],
      variants: {
        small: {styleLess: 'flex-direction: column; align-items: center;'},
      },
    },
    {
      _id: '53b66045-edd4-1887-44fa-4a01827a4b31',
      type: 'class',
      name: 'Footer Brand',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '35aa4301-cb7a-d2a7-33f6-94294fdc6ecc',
      type: 'class',
      name: 'Footer Content',
      comb: '',
      styleLess:
        'display: grid; grid-auto-columns: 1fr; grid-column-gap: 70px; grid-row-gap: 40px; grid-template-columns: auto auto 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-column-gap: 60px;'},
        small: {styleLess: 'margin-top: 40px; grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '47d9bdd6-1c60-11c5-ba75-57d4613510d2',
      type: 'class',
      name: 'Footer Block',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {small: {styleLess: 'align-items: center;'}},
    },
    {
      _id: 'c7b87836-47af-51ef-360f-c3c02ab58565',
      type: 'class',
      name: 'Title Small',
      comb: '',
      styleLess:
        'margin-bottom: 12px; font-size: 14px; line-height: 16px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;',
      children: [],
      variants: {},
    },
    {
      _id: '8caebbb9-222c-79d6-8d8e-489d3df5f5a1',
      type: 'class',
      name: 'Footer Link',
      comb: '',
      styleLess:
        'margin-top: 12px; margin-bottom: 6px; color: #1a1b1f; font-size: 14px; line-height: 16px; text-decoration: none;',
      children: [],
      variants: {
        small_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: 'f313109b-a9f0-82bf-ee6a-7cb4500493e0',
      type: 'class',
      name: 'Footer Social Block',
      comb: '',
      styleLess:
        'display: flex; margin-top: 12px; margin-left: -12px; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {small: {styleLess: 'margin-top: 20px; margin-left: -20px;'}},
    },
    {
      _id: '7543ee55-a53c-7b23-437f-8e3d319742b8',
      type: 'class',
      name: 'Footer Social Link',
      comb: '',
      styleLess: 'margin-left: 12px;',
      children: [],
      variants: {small: {styleLess: 'margin-left: 20px;'}},
    },
    {
      _id: '85355063-dd48-e9d4-b0bd-28842db06b01',
      type: 'class',
      name: 'Footer Divider',
      comb: '',
      styleLess:
        'width: 100%; height: 1px; margin-top: 70px; margin-bottom: 15px; background-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {small: {styleLess: 'margin-top: 60px;'}},
    },
    {
      _id: 'bc2a7d39-c31e-404b-43ad-f4eab7f73dbb',
      type: 'class',
      name: 'Footer Copyright Center',
      comb: '',
      styleLess: 'font-size: 14px; line-height: 16px; text-align: center;',
      children: [],
      variants: {},
    },
  ],
} as const;
